/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Filter_Compliance_LlmInputs */



/**
* | output |
* | --- |
* | "Compliance LLM" |
*
* @param {Audit_Logs_Filter_Compliance_LlmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_filter_compliance_llm = /** @type {((inputs?: Audit_Logs_Filter_Compliance_LlmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Filter_Compliance_LlmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance LLM")
	return /** @type {LocalizedString} */ ("Compliance LLM")
});